import { render, staticRenderFns } from "./ProducerDashboard.vue?vue&type=template&id=6a1b71a4&scoped=true&"
import script from "./ProducerDashboard.vue?vue&type=script&lang=js&"
export * from "./ProducerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b71a4",
  null
  
)

export default component.exports